export const FEATURES_MOCK = [
  {
    id: 1,
    backgroundStyle: "linear-gradient(135deg, rgba(243, 33, 215, 0.9), rgba(255, 236, 97, 0.9))",
    hoverBackgroundStyle: "linear-gradient(45deg, rgba(255, 236, 97, 0.9), rgba(243, 33, 215, 0.9))",
    imageSrc: "/images/dashboard/FunctionalCard.jpg",
    name: "Managing Discomfort",
  },
  {
    id: 2,
    backgroundStyle: "linear-gradient(135deg, rgba(243, 33, 215, 0.9), rgba(255, 236, 97, 0.9))",
    hoverBackgroundStyle: "linear-gradient(45deg, rgba(255, 236, 97, 0.9), rgba(243, 33, 215, 0.9))",
    imageSrc: "/images/dashboard/FunctionalGoalCard-2.png",
    name: "Functional Independence & Daily Living",
  },
  {
    id: 3,
    backgroundStyle: "linear-gradient(135deg, rgba(105, 65, 198, 0.9), rgba(84, 205, 242, 0.9))",
    hoverBackgroundStyle: "linear-gradient(45deg, rgba(84, 205, 242, 0.9), rgba(105, 65, 198, 0.9))",
    imageSrc: "/images/dashboard/FunctionalGoalCard-3.png"
  },
  {
    id: 6,
    backgroundStyle: "linear-gradient(135deg, rgba(154, 78, 255, 0.9), rgba(36, 255, 114, 0.9))",
    hoverBackgroundStyle: "linear-gradient(45deg, rgba(36, 255, 114, 0.9), rgba(154, 78, 255, 0.9))",
    imageSrc: "/images/dashboard/FunctionalGoalCard-6.png",
    name : "Performance Enhancement",
  },
  {
    id: 7,
    title: "Holistic Well-being & Quality of Life",
    backgroundStyle: "linear-gradient(135deg, rgba(118, 116, 189, 0.9), rgba(255, 236, 97, 0.9))",
    hoverBackgroundStyle: "linear-gradient(45deg, rgba(118, 116, 189, 0.9), rgba(255, 236, 97, 0.9))",
    imageSrc: "/images/dashboard/FunctionalGoalCard-7.jpg",
    name: "Injury Prevention",
  },
  {
    id: 10,
    backgroundStyle: "linear-gradient(135deg, rgba(105, 65, 198, 0.9), rgba(84, 205, 242, 0.9))",
    hoverBackgroundStyle: "linear-gradient(45deg, rgba(84, 205, 242, 0.9), rgba(105, 65, 198, 0.9))",
    imageSrc: "/images/dashboard/FunctionalGoalCard-10.png",
    name: "Holistic Well-being & Quality of Life"
  },
];